// removed by extract-text-webpack-plugin
module.exports = {"list":"list--list--Y2sdEtbt","list-item":"list--list-item--30RoPii6","listItem":"list--list-item--30RoPii6","label":"list--label--32bRp8cL"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/List/list.scss
// module id = 196
// module chunks = 0